import * as React from 'react';

export default function analytics() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.881"
      height="14.881"
      viewBox="0 0 14.881 14.881"
    >
      <g transform="translate(-68 -347)">
        <path
          d="M16.228,3H4.653A1.658,1.658,0,0,0,3,4.653V16.228a1.658,1.658,0,0,0,1.653,1.653H16.228a1.658,1.658,0,0,0,1.653-1.653V4.653A1.658,1.658,0,0,0,16.228,3ZM7.96,14.574H6.307V8.787H7.96Zm3.307,0H9.614V6.307h1.653Zm3.307,0H12.921V11.267h1.653Z"
          transform="translate(65 344)"
          fill="#fff"
          opacity="0.6"
        />
      </g>
    </svg>
  );
}
